import { render, staticRenderFns } from "./AscentGymMultiCheckItem.vue?vue&type=template&id=1e5454b6"
import script from "./AscentGymMultiCheckItem.vue?vue&type=script&lang=js"
export * from "./AscentGymMultiCheckItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports